import { NAME } from './constants';
import Card from './Card.vue';

export const PlanSkutecnost = {
	name: NAME,
	components: {
		Card,
	},
};
